import { Component } from '@angular/core';
import { HeaderModalType } from '@core/enums/header-modals';
import { environment } from '@env/environment';

@Component({
  selector: 'prism-footer',
  standalone: false,
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  isLoginVisible: boolean = false;
  isForgotPwVisible: boolean = false;
  successModal: boolean = false;
  HeaderModalType = HeaderModalType;
  isSiteOffline = environment.isSiteOffline || false;

  toggleModal(modalType: string): void {
    this.isLoginVisible = modalType === HeaderModalType.Login;
    this.isForgotPwVisible = modalType === HeaderModalType.ForgotPw;
    this.successModal = modalType === HeaderModalType.ForgotPwConfirmation;
  }
  

}
